/*
 * Authors: mariushirjanu
 * Created: 22/08/2022
 */
import { Component, Input, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { GlobalProductDataService, IGlobalItem, IProductImagesHolder } from './global-product-data.service';
import { GaEventService } from '../../shared/services/ga-event.service';
import { GlobalProductService } from './global-product.service';
import { TitleService } from '../../shared/services/title.service';
import { BodyClassService } from '../../shared/services/body-class.service';
import { EVENT_GLOBAL_PRODUCT_IMAGES_LOADED } from '../../shared/app-events';
import { STATE_GLOBALPRODUCT_NEW_GENERAL } from '../../shared/app-states';

@Component({
  selector: 'global-product',
  template: `
    <h2 *ngIf="initialLoadProduct">
      <activity-indicator toLoad="product"></activity-indicator>
    </h2>
    
    <div *ngIf="!initialLoadProduct">
      <div *ngIf="!newProduct && product || newProduct" ui-view></div>
    </div>
  `,
  styleUrls: ['global-product.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlobalProductComponent implements OnInit, OnDestroy {
  @Input() public productId:number;
  @Input() public newProduct:boolean;

  public initialLoadProduct:boolean;
  public product:IGlobalItem;

  constructor(
    private gaEventService:GaEventService,
    private globalProductDataService:GlobalProductDataService,
    private bodyClassService:BodyClassService,
    private globalProductService:GlobalProductService,
    private titleService:TitleService,
    private stateService:StateService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
  }

  private start = ():void => {
    this.bodyClassService.add('globalproduct');
    this.getStateParams();

    if (this.productId && !this.newProduct) {
      this.globalProductDataService.product(this.productId)
        .then(this.loadingDone)
        .finally(() => {
          this.initialLoadProduct = false;
        });

      this.globalProductDataService.images(this.productId)
        .then(this.loadingImagesDone);
    }

    if (this.productId || this.newProduct) {
      this.titleService.setTitle('globalproducts - new product');
      this.initialLoadProduct = false;
    }
  };

  private getStateParams():void {
    if (this.stateService.current.name !== STATE_GLOBALPRODUCT_NEW_GENERAL && this.newProduct) {
      this.stateService.go(STATE_GLOBALPRODUCT_NEW_GENERAL);
    }
  }

  private loadingDone = (result:IGlobalItem) => {
    if (result) {
      this.globalProductService.product(result);
      this.product = result;
    }
  };

  private loadingImagesDone = (result:IProductImagesHolder) => {
    if (result.images || result.modelImages) {
      this.globalProductService.images(result);
    }
    this.gaEventService.sendMessage(EVENT_GLOBAL_PRODUCT_IMAGES_LOADED);
  };

  public ngOnDestroy():void {
    this.bodyClassService.remove('globalproduct');
    this.globalProductDataService.clear();
    this.globalProductService.clearData();
  }
}